import { Component, input } from '@angular/core';
import { type FormGroup } from '@angular/forms';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';

@Component({
  selector: 'input-text-respond',
  imports: [InfoboxComponent, ProsemirrorBasicConfigDirective, RenderDirective],
  template: `
    <ng-template #subheadingTpl>
      <div
        class="description"
        prosemirrorBasicConfig
        [prosemirrorRender]="respondConfig().textJson"
        [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
      ></div>
    </ng-template>
    <rt-infobox
      subheading="_"
      [subheadingTpl]="subheadingTpl"
      [hasDotDivider]="false"
      [isDismissible]="false"
    />
  `,
})
export class RespondInfoboxComponent {
  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  public respondConfig = input.required<{ textJson: object }>();
  public respondForm = input.required<FormGroup<{}>>();
}
